"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ifTagsNotSelected = exports.ifTagsSelected = void 0;

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var lodash_1 = require("lodash");

var TagModel_1 = __importDefault(require("./TagButton/TagModel"));
/**
 * Determine which component to show based on selected tags.
 * @param selectedTags
 *  The selected tags to use.
 */


var useToggleByTags = function useToggleByTags(_a) {
  var selectedTags = _a.selectedTags;
  var getTags = TagModel_1.default().getTags;
  var tags = getTags(); // Show all items if there is no selected tag.

  if (lodash_1.isEmpty(selectedTags)) {
    return true;
  }

  return lodash_1.differenceWith(selectedTags, tags, function (selectedTag, itemTag) {
    return selectedTag.name === itemTag.name;
  }).length === 0;
};

var ifTagsSelected = core_1.ifToggledOn(useToggleByTags);
exports.ifTagsSelected = ifTagsSelected;
var ifTagsNotSelected = core_1.ifToggledOff(useToggleByTags);
exports.ifTagsNotSelected = ifTagsNotSelected;
var withFilterByTags = lodash_1.flowRight(ifTagsNotSelected(fclasses_1.replaceWith(function () {
  return null;
})), core_1.withoutProps(['selectedTags']));
exports.default = withFilterByTags;